export const AdCarouselWithText = {};

export const RatingCarouselProps = {
  cardData: [
    {
      id: '0',
      rating: 5,
      description: 'Wie immer, tolle Preise große Auswahl und schnelle Lieferung.',
      author: 'Peter K.',
      date: '2024-05-11'
    },
    {
      id: '1',
      rating: 5,
      description: 'Immer sehr verlässlich. Preis-Leistung passt.',
      author: 'Silvio Z.',
      date: '2022-06-12'
    },
    {
      id: '2',
      rating: 5,
      description: 'Alles wie beschrieben und schnell geliefert.',
      author: 'Guido P.',
      date: '2024-08-30'
    },
    {
      id: '3',
      rating: 5,
      description: 'Schneller Versand, gute Ware, faire Preise, verlockende Rabattaktionen. Alles Bestens!!',
      author: 'Maximilian S.',
      date: '2024-09-11'
    }
  ]
};

export const OverviewProps = {
  items: [
    {
      headline: 'Hochwertige und geprüfte Produkte',
      body: 'Vitafy bietet eine breite Auswahl an sorgfältig geprüften Produkten, die regelmäßig im Labor auf Qualität, Reinheit und Sicherheit getestet werden.'
    },
    {
      headline: 'Umfassende Produktvielfalt',
      body: 'Mit über 5000 Produkten führender Marken aus den Bereichen Fitness, Gesundheit, Ernährung und Wellness findest du alles, was du für ein gesünderes und vitaleres Leben brauchst.'
    },
    {
      headline: 'Transparenz und Kundenvertauen',
      body: 'Detaillierte Produkt-beschreibungen, klare Nährwertangaben und Kundenbewertungen schaffen Transparenz und Vertrauen, sodass du fundierte Entscheidungen treffen kannst.'
    }
  ]
};
